// import Layout from '@/components/Common/Layout/Layout';

import ReviewAndSign from '@/components/upload/ReviewAndSign';
import { useEffect } from 'react';

const Test = () => {
  useEffect(() => {
    console.log('HEYYYYYY');
  }, []);

  return (
    <div>
      <ReviewAndSign />
    </div>
  );
  // return (
  //   <Layout.Main
  //     headerProps={{
  //       title: 'This is a test page',
  //       description: 'some dummy description here',
  //     }}
  //   >
  //     o sweet child of mine
  //   </Layout.Main>
  // );
};

export default Test;
